<script lang="ts">
  import type { MimirSearchHit, NtbSearchHit } from "services/searchHit";
  import { searchParams } from "state/page";
  import { getSearchHitsFromQuery } from "state/queries";
  import {
    createNtbSearchQuery,
    type SearchNtbQueryResult,
    setNtbSearchHitsContext,
    setNtbSearchQuery,
  } from "state/queries/ntb";
  import {
    createMimirSearchQuery,
    setMimirSearchContext,
    setMimirSearchQuery,
    type MimirSearchQueryResult,
  } from "state/queries/mimir";
  import { writable } from "svelte/store";
  import { notify } from "services/notifications";
   
  // Bildebanken search query
  $: mimirQuery = createMimirSearchQuery($searchParams);
  $: if ($mimirQuery.error) {
    notify("Fikk ikke svar fra Bildebanken-søket. Er du på nett?", "warning", 5000);
  }
  const mergedHits = writable([] as MimirSearchHit[]);
  const mergedQuery = writable<MimirSearchQueryResult>();
  $: mimirSearchHits = getSearchHitsFromQuery(mimirQuery);

  // Loading many search hits causes blocking rendering (because there are so many changes),
  // which means some changes that should be immediately rendered (e.g. input elements for filters),
  // aren't responsive enough. The below allows those changes to render before the search hit
  // rendering blocks everything else.
  $: setTimeout(() => mergedHits.set($mimirSearchHits), 0);
  $: mergedQuery.set($mimirQuery);
  setMimirSearchContext(mergedHits);
  setMimirSearchQuery(mergedQuery);

  // NTB search query
  $: ntbQuery = createNtbSearchQuery($searchParams);
  $: if ($ntbQuery.error) {
    notify("Klarte ikke søke i NTB. Prøv å gå til http://bilder.ntb.no og se om NTB fungerer der", "warning", 5000);
  }
  const mergedHitsNtb = writable([] as NtbSearchHit[]);
  const mergedNtbQuery = writable<SearchNtbQueryResult>();
  $: searchHitsNtb = getSearchHitsFromQuery(ntbQuery);
  $: mergedNtbQuery.set($ntbQuery);
  $: setTimeout(() => mergedHitsNtb.set($searchHitsNtb), 0);
  setNtbSearchHitsContext(mergedHitsNtb);
  setNtbSearchQuery(mergedNtbQuery);
</script>

<slot />
